// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__258O5","signatureButtonsRight":"ModalSign_signatureButtonsRight__3ad4v"};